import { Injectable } from '@angular/core';
import { UserAlertDialogComponent, UserAlertDialogData } from '@shared/components/user-alert-dialog/user-alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CassError } from '@core/models/cass-error';
import { Observable, combineLatest, of, shareReplay, switchMap, take, map } from 'rxjs';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class UserAlertService {

	constructor(
		public dialog: MatDialog,
		private _snackBar: MatSnackBar,
		private _translate: TranslateService) {
	}

	// TBD: return Observable/Promise to let the caller know that the dialog is closed
	errorByTranslationKey(translationKey: string, interpolateParams: any | undefined = undefined): void {
		this._translate.get(translationKey, interpolateParams).toPromise().then(msg =>
			this.error(msg)
		);
	}

	errorByCassError(cassError: CassError): void {
		let msg = undefined;
		if (cassError && cassError.errorMessageKey) {
			this._translate.get(cassError.errorMessageKey, cassError.errorInterpolateParams).toPromise().then(msg =>
				this.error(msg)
			);
		}
		else if (cassError && cassError.errorMessage) {
			msg = cassError.errorMessage;
			this.error(msg);
		}
		else {
			this._translate.get("ERRORS.UNKNOWN_ERROR").toPromise().then(msg =>
				this.error(msg)
			);
		}
	}

	error(msg: string) {
		this._translate.get("ERRORS.ERROR_TITLE").toPromise().then(errorTitle =>
			this.showDialog(true, errorTitle, msg)
		);
	}

	messageByTranslateKey(
		messageTranslationKey: string,
		messageInterpolateParams: any | undefined = undefined,
		titleTranslationKey: string | undefined = undefined,
		titleInterpolateParams: Object | undefined = undefined
	): Observable<undefined> {
		const ob$ = combineLatest([
				titleTranslationKey ? this._translate.get(titleTranslationKey, titleInterpolateParams) : of(undefined),
				this._translate.get(messageTranslationKey, messageInterpolateParams)
				])
			.pipe(
				take(1), // don't require unsubscribe
				switchMap(([title, msg]) => this.showDialog(false, title, msg)),
				shareReplay() // don't retrigger dialog on multiple subscriptions
			);
		// We don't want to force the caller to subscribe, so we do so here, and return the observable.
		// Since showing (and dismissing) a dialog is a 'slow' operation, the caller can still subscribe and wait for the dialog closure.
		// No need to unsubscribe.
		ob$.subscribe();
		return ob$;
	}

	showDialog(isError: boolean, title: string | undefined, msg: string): Observable<undefined> {
		// TODO refactor this into the Dialog component
		const userAlertDialogData: UserAlertDialogData = {
			title: title,
			message: msg,
			error: isError
		};
		const dialogRef = this.dialog.open<UserAlertDialogComponent, UserAlertDialogData, undefined>(UserAlertDialogComponent, { data: userAlertDialogData });
		return dialogRef.afterClosed();
	}

	//showSuccessSnackbar(messageTranslationKey: string, messageInterpolateParams: any | undefined = undefined, durationInSeconds: number = 3): Observable<MatSnackBarRef<TextOnlySnackBar>> {

	//	return this._translate.get(messageTranslationKey, messageInterpolateParams).pipe(
	//		map((msg: string) => {
	//			const snackBarRef = this._snackBar.open(msg, undefined, {
	//				duration: durationInSeconds * 1000,
	//				verticalPosition: "top",
	//				horizontalPosition: "right",
	//				panelClass: "cass-notification-snackbar-success"
	//			});

	//			return snackBarRef;
	//		})
	//	);
	//}

	showSuccessSnackbar(message: string, durationInSeconds: number = 3): MatSnackBarRef<TextOnlySnackBar> {
		return this._snackBar.open(message, undefined, {
			duration: durationInSeconds * 1000,
			verticalPosition: "top",
			horizontalPosition: "right",
			panelClass: "cass-notification-snackbar-success"
		});
	}


	//showSuccessSnackbar(messageTranslationKey: string, messageInterpolateParams: any | undefined = undefined, durationInSeconds: number = 3): MatSnackBarRef<TextOnlySnackBar> {

	//	// const message = this._translate.instant(messageTranslationKey, messageInterpolateParams);

	//	this._translate.instant(messageTranslationKey, messageInterpolateParams).toPromise();


	//	const snackBarRef = this._snackBar.open(message, undefined, {
	//		duration: durationInSeconds * 1000,
	//		verticalPosition: "top",
	//		horizontalPosition: "right",
	//		panelClass: "cass-notification-snackbar-success"
	//	});

	//	return snackBarRef;
	//}

}
